<template>
  <section class="container">
    <div class="is-light mb-6">
      <div class="columns mb-0">
        <div class="column">
          <div class="intro-container mb-0">
            <h1 class="title gant-text">Welcome to TripCircuit, {{ $globals.profile.firstName }}</h1>
            <h2 class="subtitle">Your Online Travel Platform</h2>
          </div>
        </div>
      </div>
      

      

      <!-- Main Layout: Search Forms + Trips Sidebar -->
      <div class="columns">
        <!-- Left Column: Search Forms -->
        <div class="column is-8">

          <div class="boxWithBorder mb-4" style="min-height: 50px;" v-if="companyNotes && companyNotes.isActive">
            <h4 class="title is-6 mb-3">
              <b-icon icon="message-text" class="mr-2"></b-icon>
              Company Notes
            </h4>
            <div
              class="company-notes-content content is-small"
              :class="{ 'company-notes-collapsed': !isCompanyNotesExpanded && hasLongCompanyNotes }"
              ref="companyNotesContent"
            >
              <div v-html="companyNotes.content"></div>
            </div>
            <div v-if="hasLongCompanyNotes" class="mt-3">
              <b-button
                type="is-text"
                size="is-small"
                @click="toggleCompanyNotes"
                class="company-notes-toggle"
              >
                <b-icon
                  :icon="isCompanyNotesExpanded ? 'chevron-up' : 'chevron-down'"
                  size="is-small"
                ></b-icon>
                <span v-if="isCompanyNotesExpanded">Show less</span>
                <span v-else>Show more</span>
              </b-button>
            </div>
          </div>

          <div class="boxWithBorder">
            <div class="level">
              <div class="level-left">
                <h3 class="title is-4 mb-0">
                  <b-icon icon="magnify" class="mr-2"></b-icon>
                  Search & Book Travel
                </h3>
              </div>
              <div class="level-right">
                <b-button type="is-secondary mr-2" size="is-small" @click="goToSearchPage">
                  <span class="has-text-grey is-size-7">Book for someone else</span>
                  <!-- <b-icon icon="pencil" size="is-small" class="ml-1"></b-icon> -->
                </b-button>
                <b-button type="is-secondary" size="is-small" @click="goToSearchPage">
                  <span class="has-text-grey is-size-7">Book a personal trip</span>
                </b-button>
              </div>
            </div>
            
            <!-- Search Tabs -->
            <b-tabs v-model="activeTab" type="is-boxed search-tabs">
              <!-- Flight Search Tab -->
              <b-tab-item label="Flights" icon="airplane">
                <FlightSearchForm @search="handleFlightSearch" class="mt-4" />
              </b-tab-item>

              <!-- Hotel Search Tab -->
              <b-tab-item label="Hotels" icon="bed">
                <HotelSearchForm @search="handleHotelSearch" class="mt-4"  />
              </b-tab-item>

              <!-- Car Search Tab -->
              <b-tab-item label="Cars" icon="car">
                <CarSearchForm @search="handleCarSearch" class="mt-4"  />
              </b-tab-item>
            </b-tabs>
          </div>

          <!-- Support Section with Accordion -->
          <div class="boxWithBorder mt-5">
            <h3 class="title is-4 mb-4">
              <b-icon icon="help-circle" class="mr-2"></b-icon>
              Get Support
            </h3>

            <div class="support-accordion">
              <!-- Same-day travel or after-hours assistance -->
              <div class="accordion-item" :class="{ 'is-active': activeAccordion === 'sameday' }">
                <div class="accordion-header" @click="toggleAccordion('sameday')">
                  <div class="accordion-title">
                    <b-icon icon="clock-fast" class="mr-2"></b-icon>
                    <span>Booking same-day travel or need after-hours assistance</span>
                  </div>
                  <b-icon
                    :icon="activeAccordion === 'sameday' ? 'chevron-up' : 'chevron-down'"
                    class="accordion-chevron"
                  ></b-icon>
                </div>
                <div class="accordion-content" v-show="activeAccordion === 'sameday'">
                  <div class="support-methods">
                    <div class="support-method">
                      <b-icon icon="chat" class="mr-2"></b-icon>
                      <div>
                        <div class="method-label">Chat with us</div>
                        <b-button type="is-primary" size="is-small mt-2" @click="startLiveChat">
                          Start chat
                        </b-button>
                      </div>
                    </div>
                    <div class="support-method">
                      <b-icon icon="phone" class="mr-2"></b-icon>
                      <div>
                        <div class="method-label">Call us</div>
                        <a href="tel:877-924-0303">877-924-0303</a>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <!-- Help with booking or reservation -->
              <div class="accordion-item" :class="{ 'is-active': activeAccordion === 'booking' }">
                <div class="accordion-header" @click="toggleAccordion('booking')">
                  <div class="accordion-title">
                    <b-icon icon="calendar-check" class="mr-2"></b-icon>
                    <span>Booking a new trip or help with an existing reservation</span>
                  </div>
                  <b-icon
                    :icon="activeAccordion === 'booking' ? 'chevron-up' : 'chevron-down'"
                    class="accordion-chevron"
                  ></b-icon>
                </div>
                <div class="accordion-content" v-show="activeAccordion === 'booking'">
                  <div class="support-methods">
                    <div class="support-method">
                      <b-icon icon="chat" class="mr-2"></b-icon>
                      <div>
                        <div class="method-label">Chat with us</div>
                        <b-button type="is-primary" size="is-small mt-2" @click="startLiveChat">
                          Start chat
                        </b-button>
                      </div>
                    </div>
                    <div class="support-method">
                      <b-icon icon="phone" class="mr-2"></b-icon>
                      <div>
                        <div class="method-label">Call us</div>
                        <a href="tel:877-924-0303">877-924-0303</a>
                      </div>
                    </div>
                    <div class="support-method">
                      <b-icon icon="email" class="mr-2"></b-icon>
                      <div>
                        <div class="method-label">Email us</div>
                        <a href="mailto:travelsupport@ganttravel.com">travelsupport@ganttravel.com</a>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <!-- Help with TripCircuit, profile, invoices -->
              <div class="accordion-item" :class="{ 'is-active': activeAccordion === 'tripcircuit' }">
                <div class="accordion-header" @click="toggleAccordion('tripcircuit')">
                  <div class="accordion-title">
                    <b-icon icon="account-cog" class="mr-2"></b-icon>
                    <span>Profile, invoices, and account help</span>
                  </div>
                  <b-icon
                    :icon="activeAccordion === 'tripcircuit' ? 'chevron-up' : 'chevron-down'"
                    class="accordion-chevron"
                  ></b-icon>
                </div>
                <div class="accordion-content" v-show="activeAccordion === 'tripcircuit'">
                  <div class="support-methods">
                    <div class="support-method">
                      <b-icon icon="chat" class="mr-2"></b-icon>
                      <div>
                        <div class="method-label">Chat with us</div>
                        <b-button type="is-primary" size="is-small mt-2" @click="startLiveChat">
                          Start chat
                        </b-button>
                      </div>
                    </div>
                    <div class="support-method">
                      <b-icon icon="email" class="mr-2"></b-icon>
                      <div>
                        <div class="method-label">Email us</div>
                        <a href="mailto:clientservices@ganttravel.com">clientservices@ganttravel.com</a>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <!-- International Travel -->
              <div class="accordion-item" :class="{ 'is-active': activeAccordion === 'international' }">
                <div class="accordion-header" @click="toggleAccordion('international')">
                  <div class="accordion-title">
                    <b-icon icon="earth" class="mr-2"></b-icon>
                    <span>Traveling internationally</span>
                  </div>
                  <b-icon
                    :icon="activeAccordion === 'international' ? 'chevron-up' : 'chevron-down'"
                    class="accordion-chevron"
                  ></b-icon>
                </div>
                <div class="accordion-content" v-show="activeAccordion === 'international'">
                  <div class="support-methods">
                    <div class="support-method">
                      <b-icon icon="passport" class="mr-2"></b-icon>
                      <div>
                        <div class="method-label">View international visa requirements</div>
                        <a href="https://cibtvisas.com/gant-travel?login=ganttravel" target="_blank" class="button is-primary has-text-white is-small mt-2">
                          Check Visa Requirements
                        </a>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>


          

          
        </div>

        <!-- Right Column: Upcoming Trips -->
        <div class="column is-4">
          <div class="boxWithBorder">
            <div class="level mb-4">
              <div class="level-left">
                <h4 class="title is-5">
                  <b-icon icon="briefcase" class="mr-2"></b-icon>
                  Upcoming Trips
                </h4>
              </div>
              <div class="level-right">
                <b-button type="is-text" size="is-small" @click="viewAllTrips">View all trips</b-button>
              </div>
            </div>

            <!-- Trip Loading State -->
            <div v-if="tripsLoading">
              <b-skeleton :animated="true" height="60px" class="mb-3"></b-skeleton>
              <b-skeleton :animated="true" height="60px" class="mb-3"></b-skeleton>
              <b-skeleton :animated="true" height="60px"></b-skeleton>
            </div>

            <!-- Trip List -->
            <div v-else-if="upcomingTrips.length > 0">
              <TripListCompact :trips="limitedTrips" :force-stacked="true" />
            </div>

            <!-- No Trips State -->
            <div v-else class="has-text-centered">
              <b-icon icon="briefcase-outline" size="is-large" type="is-grey-light" class="mb-3"></b-icon>
              <p class="title is-6 mb-2">No upcoming trips</p>
            </div>
          </div>


        </div>
      </div>
    </div>
  </section>
</template>

<script>
import FlightSearchForm from '../components/HomeV2/FlightSearchForm'
import HotelSearchForm from '../components/HomeV2/HotelSearchForm'
import CarSearchForm from '../components/HomeV2/CarSearchForm'
import TripListCompact from '../components/Trip/TripListCompact'
import { mapGetters } from 'vuex'

export default {
  name: 'HomeV2',
  components: {
    FlightSearchForm,
    HotelSearchForm,
    CarSearchForm,
    TripListCompact
  },
  data() {
    return {
      activeTab: 0,
      upcomingTrips: [],
      tripsLoading: true,
      maxTripsToShow: 3,
      isCompanyNotesExpanded: false,
      hasLongCompanyNotes: false,
      activeAccordion: null,
      // Event tracking flags to prevent duplicates
      searchStartedEvents: {
        flight: false,
        hotel: false,
        car: false
      }
    }
  },
  computed: {
    ...mapGetters('travellersAndTrips', ['getActiveAccountNoteBySection']),

    limitedTrips() {
      return this.upcomingTrips.slice(0, this.maxTripsToShow)
    },

    companyNotes() {
      return this.getActiveAccountNoteBySection('home')
    }
  },

  watch: {
    companyNotes() {
      this.$nextTick(() => {
        this.checkCompanyNotesHeight()
      })
    },

    activeTab(newTab) {
      // Log Search Started event when user switches to a different search tab
      const tabTypes = ['flight', 'hotel', 'car']
      if (newTab >= 0 && newTab < tabTypes.length) {
        this.logSearchStartedEvent(tabTypes[newTab])
      }
    }
  },
  methods: {
    async loadUpcomingTrips() {
      try {
        this.tripsLoading = true
        
        // Get pending trips from store
        let pendings = this.$store.state.travellersAndTrips.pendingTrips || []
        pendings.forEach(trip => { trip.pending = true })

        // Fetch active trips from API
        const tripsPayload = {
          meta: {
            stateful: false,
            sessionKey: null,
            normalizeResponse: true
          },
          travelerProfileRecordLocator: this.$globals.profile.amadeusRecordLocator,
          onlyActiveTrips: true,
          officeId: this.$globals.profile.officeId
        }

        const result = await this.$app.huddleLabsServerCall('amadeus/trips/get-trips', tripsPayload)
        
        if (result.data && result.data.length > 0) {
          // Fetch detailed trip information for each trip
          const tripPromises = result.data.map(async (tripSummary) => {
            const detailPayload = {
              meta: {
                stateful: false,
                sessionKey: null,
                normalizeResponse: true
              },
              recordLocator: tripSummary.recordLocator
            }
            
            const detailResult = await this.$app.huddleLabsServerCall('amadeus/trips/show', detailPayload)
            return detailResult.data
          })
          
          const detailedTrips = await Promise.all(tripPromises)
          // Filter out cancelled trips
          const activeTrips = detailedTrips.filter(trip => trip?.tripSummary?.status !== 'cancelled')
          this.upcomingTrips = [...pendings, ...activeTrips]
        } else {
          this.upcomingTrips = pendings
        }
      } catch (error) {
        console.error('Error loading trips:', error)
        this.upcomingTrips = []
      } finally {
        this.tripsLoading = false
      }
    },

    formatTripDates(startDate, endDate) {
      const start = this.$moment(startDate).format('MMM D')
      const end = this.$moment(endDate).format('MMM D, YYYY')

      if (startDate === endDate) {
        return this.$moment(startDate).format('MMM D, YYYY')
      }
      return `${start} - ${end}`
    },

    formatDate(date) {
      return this.$moment(date).format('MMM D, YYYY')
    },

    formatDestination(destination) {
      if (typeof destination === 'string') {
        return destination
      }

      if (destination.city && destination.state) {
        return `${destination.city}, ${destination.state}`
      }

      if (destination.city) {
        return destination.city
      }

      if (destination.name) {
        return destination.name
      }

      return 'Unknown Destination'
    },

    getDaysUntilTrip(startDate) {
      if (!startDate) return 'Unknown'

      const today = new Date()
      const tripDate = new Date(startDate)

      // Reset time to start of day for accurate day calculation
      today.setHours(0, 0, 0, 0)
      tripDate.setHours(0, 0, 0, 0)

      const diffTime = tripDate - today
      const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24))

      if (diffDays < 0) {
        return 'In Progress'
      } else if (diffDays === 0) {
        return 'Today'
      } else if (diffDays === 1) {
        return 'Tomorrow'
      } else if (diffDays <= 7) {
        return `${diffDays} days`
      } else if (diffDays <= 30) {
        return `${Math.ceil(diffDays / 7)} weeks`
      } else {
        return `${Math.ceil(diffDays / 30)} months`
      }
    },

    async handleFlightSearch(searchData) {
      try {
        // Log Search Submitted event with proper itinerary type
        let itineraryType = 'one_way'
        if (searchData.tripType === 'roundtrip') {
          itineraryType = 'round_trip'
        } else if (searchData.tripType === 'multicity') {
          itineraryType = 'multi_city'
        }

        this.logSearchSubmittedEvent('air', {
          itinerary_type: itineraryType
        })

        // Handle different trip types
        if (searchData.tripType === 'multicity') {
          // For multi-city searches, store the multi-city data
          const multiCityFormData = {
            tripVal: 2, // 2 = multi-city
            cabinClass: searchData.cabinClass,
            multiCitySegments: searchData.multiCitySegments
          }

          // Store the multi-city form data in the bookTravel store
          this.$store.commit('bookTravel/SET_MULTI_CITY_FORM_DATA', multiCityFormData)
        } else {
          // For one-way and round-trip, use the existing logic
          const formData = {
            tripVal: searchData.tripType === 'oneway' ? 0 : 1, // 0 = one-way, 1 = round-trip
            cabinClass: searchData.cabinClass,
            loc1: searchData.from,
            loc2: searchData.to,
            startDate: {
              date: searchData.departureDate,
              advanced: {
                time: null,
                isDeparture: true,
                tod: searchData.departureTimePreference,
                hours: 2
              }
            },
            endDate: {
              date: searchData.returnDate,
              advanced: {
                time: null,
                isDeparture: true,
                tod: searchData.returnTimePreference,
                hours: 2
              }
            }
          }

          // Store the form data in the bookTravel store
          this.$store.commit('bookTravel/SET_FLIGHT_FORM_DATA', formData)
        }

        // Navigate to flight search page with flag to prevent duplicate Search Started event
        this.$router.push({
          name: 'BookingFlights',
          query: { fromHome: 'true' }
        })
      } catch (error) {
        console.error('Error handling flight search:', error)
        this.$buefy.toast.open({
          message: 'Error starting flight search. Please try again.',
          type: 'is-danger'
        })
      }
    },

    async handleHotelSearch(searchData) {
      try {
        // Log Search Submitted event
        this.logSearchSubmittedEvent('hotel')

        // Use the full location name from Google Places API if available, otherwise fall back to user input
        let locationName = searchData.destination
        if (searchData.googlePlace && searchData.googlePlace.formatted_address) {
          locationName = searchData.googlePlace.formatted_address
        } else if (searchData.googlePlace && searchData.googlePlace.name) {
          locationName = searchData.googlePlace.name
        }

        // Set up hotel search state in Vuex store
        this.$store.commit('hotelSearch/SET_SEARCH_LOCATION', {
          name: locationName,
          latitude: searchData.googlePlace?.geometry?.location?.lat() || 0,
          longitude: searchData.googlePlace?.geometry?.location?.lng() || 0
        })

        this.$store.commit('hotelSearch/SET_SEARCH_DATES', [
          searchData.checkinDate,
          searchData.checkoutDate
        ])

        this.$store.commit('hotelSearch/SET_SELECTED_HOTEL_RATES', searchData.selectedRates || [])

        // Navigate to hotel search page and trigger search with flag to prevent duplicate Search Started event
        this.$router.push({
          name: 'BookingHotels',
          query: { fromHome: 'true' }
        })

        // Trigger the search after navigation
        this.$nextTick(() => {
          this.$store.dispatch('hotelSearch/getData', { cacheKey: null })
        })
      } catch (error) {
        console.error('Error handling hotel search:', error)
        this.$buefy.toast.open({
          message: 'Error starting hotel search. Please try again.',
          type: 'is-danger'
        })
      }
    },

    async handleCarSearch(searchData) {
      try {
        // Log Search Submitted event
        this.logSearchSubmittedEvent('car')

        // Store car search data in bookTravel store for CarForm to pick up
        this.$store.commit('bookTravel/SET_CAR_SEARCH_DATA', {
          pickupLocation: searchData.pickupLocation,
          dropoffLocation: searchData.dropoffLocation,
          pickupDate: searchData.pickupDate,
          dropoffDate: searchData.dropoffDate,
          pickupTime: this.formatTimeForCarForm(searchData.pickupTime),
          dropoffTime: this.formatTimeForCarForm(searchData.dropoffTime),
          rentalCompany: searchData.rentalCompany,
          differentDropoff: searchData.differentDropoff,
          airportSearch: searchData.airportSearch,
          airportSearchDropoff: searchData.airportSearchDropoff
        })

        // Navigate to car search page with flag to prevent duplicate Search Started event
        this.$router.push({
          name: 'BookingCars',
          query: { fromHome: 'true' }
        })
      } catch (error) {
        console.error('Error handling car search:', error)
        this.$buefy.toast.open({
          message: 'Error starting car search. Please try again.',
          type: 'is-danger'
        })
      }
    },

    viewAllTrips() {
      this.$router.push('/planned-trips')
    },

    viewTripDetail(recordLocator) {
      const encodedLocator = this.$helpers.encryptText(recordLocator)
      this.$router.push(`/trip-detail/${encodedLocator}`)
    },

    goToSearchPage() {
      this.$router.push('/search')
    },

    toggleCompanyNotes() {
      this.isCompanyNotesExpanded = !this.isCompanyNotesExpanded
    },

    checkCompanyNotesHeight() {
      if (this.$refs.companyNotesContent) {
        const element = this.$refs.companyNotesContent
        const maxHeight = 100 // Same as Notes component default
        // Add a small delay to ensure DOM is fully rendered
        this.$nextTick(() => {
          setTimeout(() => {
            this.hasLongCompanyNotes = element.scrollHeight > maxHeight
          }, 100)
        })
      }
    },

    formatTimeForCarForm(timeDate) {
      // Convert Date object or time string to HH:MM format expected by CarForm
      if (!timeDate) return '12:00'

      // If it's already a string in HH:MM format, return as is
      if (typeof timeDate === 'string') {
        return timeDate
      }

      // If it's a Date object, extract hours and minutes
      if (timeDate instanceof Date) {
        const hours = timeDate.getHours().toString().padStart(2, '0')
        const minutes = timeDate.getMinutes().toString().padStart(2, '0')
        return `${hours}:${minutes}`
      }

      // Fallback
      return '12:00'
    },
    startLiveChat() {
      this.$root.$emit("openChatWindow");
    },

    toggleAccordion(section) {
      // Toggle the accordion - close if already open, open if closed
      this.activeAccordion = this.activeAccordion === section ? null : section;
    },

    // Event tracking methods
    logSearchStartedEvent(itemType) {
      // Prevent duplicate events
      if (this.searchStartedEvents[itemType]) {
        return
      }

      this.searchStartedEvents[itemType] = true

      const eventData = {
        event_type: 'Search Started',
        event_properties: {
          item_type: itemType,
          is_meeting_mode: false // HomeV2 is not used for meetings
        }
      }

      this.$app.logEvent(eventData)
    },

    logSearchSubmittedEvent(itemType, additionalProperties = {}) {
      const eventData = {
        event_type: 'Search Submitted',
        event_properties: {
          item_type: itemType,
          is_meeting_mode: false, // HomeV2 is not used for meetings
          ...additionalProperties
        }
      }

      this.$app.logEvent(eventData)
    }
  },

  async mounted() {
    await this.loadUpcomingTrips()

    // Load company notes
    if (!this.companyNotes) {
      try {
        await this.$store.dispatch('travellersAndTrips/fetchAccountNotes')
      } catch (error) {
        console.error('Error loading company notes:', error)
      }
    }

    // Check company notes height after everything is loaded
    this.$nextTick(() => {
      this.checkCompanyNotesHeight()
    })

    // Log Search Started event for the default tab (flights - activeTab: 0)
    this.logSearchStartedEvent('flight')
  }
}
</script>


<style>
/* Non-scoped styles */


.search-tabs ul {
  margin: 0 !important;
}

.b-tabs .tab-content {
  padding: 1rem 0 !important;
}

/* End non-scoped styles */
</style>

<style scoped>

/* Remove left margin from tabs */
.tabs {
  margin-left: 0 !important;
}

.tabs ul {
  margin-left: 0 !important;
  margin: 0 !important;
}

.tabs .tabs-nav {
  margin-left: 0 !important;
}

/* Ensure tab items align to the left */
.tabs .tab-item {
  margin-left: 0 !important;
}


.trip-item {
  padding: 0.75rem 0;
}

.trip-info h6 {
  margin-bottom: 0.25rem;
}

.support-option {
  display: flex;
  align-items: flex-start;
}

.support-option .icon {
  margin-top: 0.25rem;
}

.trip-segments .taglist {
  margin-bottom: 0;
}

/* Ensure consistent spacing */
.boxWithBorder {
  min-height: 200px;
}

/* Tab content padding */
.search-tabs .tab-content {
  padding: 0 !important;
}


.intro-container {
    background: linear-gradient(0deg, #f2f2f2, #fff);
    border: 10px solid white;
    margin-bottom: 10px;
    padding: 15px;
    border-radius: 8px;
}


/* Responsive adjustments */
@media screen and (max-width: 768px) {
  .columns {
    margin: 0;
  }

  .column {
    padding: 0.75rem;
  }

  .boxWithBorder {
    min-height: auto;
    margin-bottom: 1rem;
  }

  /* Stack sidebar content vertically on mobile */
  .sidebar-content .columns {
    display: block;
  }

  .sidebar-content .column {
    width: 100%;
    padding: 0.5rem 0.75rem;
  }

  /* Adjust trip cards for mobile */
  .trip-card-header {
    flex-direction: column;
    gap: 0.5rem;
    align-items: stretch;
  }

  .trip-title-section {
    justify-content: space-between;
    flex-wrap: wrap;
    gap: 0.25rem;
  }

  .segment-icons {
    flex-wrap: wrap;
  }

  .trip-card {
    padding: 0.75rem;
  }

  /* Make support options stack better */
  .support-option {
    margin-bottom: 0.75rem;
  }

  .support-option:last-child {
    margin-bottom: 0;
  }
}

/* Tablet adjustments */
@media screen and (min-width: 769px) and (max-width: 1023px) {
  .main-content .columns {
    margin: 0 -0.5rem;
  }

  .main-content .column {
    padding: 0 0.5rem;
  }

  .boxWithBorder {
    padding: 1rem;
  }
}

/* Company Notes Collapsible Styles */
.company-notes-toggle {
  color: #3273dc;
  padding: 0.25rem;
  border-radius: 4px;
  transition: background-color 0.2s ease;
}

.company-notes-toggle:hover {
  background-color: rgba(50, 115, 220, 0.1);
}

.company-notes-content {
  transition: max-height 0.3s ease-in-out;
  overflow: hidden;
  line-height: 1.4;
}

.company-notes-collapsed {
  max-height: 100px;
  position: relative;
}

.company-notes-collapsed::after {
  content: '';
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  height: 20px;
  background: linear-gradient(transparent, white);
  pointer-events: none;
}

/* Support Accordion Styles */
.support-accordion {
  border: 1px solid #e8e8e8;
  border-radius: 8px;
  overflow: hidden;
}

.accordion-item {
  border-bottom: 1px solid #e8e8e8;
}

.accordion-item:last-child {
  border-bottom: none;
}

.accordion-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 1rem 1.25rem;
  background: #fafafa;
  cursor: pointer;
  transition: background-color 0.2s ease;
}

.accordion-header:hover {
  background: #f0f0f0;
}

.accordion-item.is-active .accordion-header {
  background: #f5f5f5;
  border-bottom: 1px solid #e8e8e8;
}

.accordion-title {
  display: flex;
  align-items: center;
  font-weight: 600;
  color: #363636;
  flex: 1;
}

.accordion-chevron {
  color: #666;
  transition: transform 0.2s ease;
}

.accordion-item.is-active .accordion-chevron {
  transform: rotate(180deg);
}

.accordion-content {
  padding: 1.25rem;
  background: white;
  border-top: 1px solid #e8e8e8;
}

.support-methods {
  display: flex;
  flex-direction: column;
  gap: 0.9rem;
}

.support-method {
  display: flex;
  align-items: flex-start;
  gap: 0.5rem;
}

.support-method .icon {
  margin-top: 0.125rem;
  color: #363636;
  flex-shrink: 0;
}

.support-method > div {
  flex: 1;
}

.method-label {
  color: #363636;
  font-weight: 600;
  font-size: 0.9rem;
  margin-bottom: 0;
}

.support-method a {
  color: #a4393a;
  text-decoration: none;
}

.support-method a:hover {
  text-decoration: underline;
}

/* Responsive accordion adjustments */
@media screen and (max-width: 768px) {
  .accordion-header {
    padding: 0.875rem 1rem;
  }

  .accordion-content {
    padding: 1rem;
  }

  .accordion-title span {
    font-size: 0.9rem;
  }

  .support-methods {
    gap: 0.625rem;
  }

  .support-method {
    gap: 0.375rem;
  }
}

/* Large screen adjustments */
@media screen and (min-width: 1408px) {
  .container {
    max-width: 1344px;
  }
}
</style>
